import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { DEFAULT_DATE_FORMAT } from 'src/app/helpers/date-format.helper';
import { GetAllGoodsFilterParams, GetAllGoodsSortParams } from 'src/app/core/data-sources/v3/inspection/inspection-data-source.v3.service';
import * as moment from 'moment';

@Component({
  selector: 'app-inspection-table-header',
  templateUrl: './inspection-table-header.component.html',
  styleUrls: ['./inspection-table-header.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMAT }]
})
export class InspectionTableHeaderComponent implements OnInit {
  @Output() filterValues = new EventEmitter();
  @Output() onSelectAll = new EventEmitter();
  @Input() allChecked: boolean;
  maxDate = new Date();
  minDate: Date;
  showCheckIcon = {};
  appliedFilters = {};
  sortDirection = '';
  sortParams: GetAllGoodsSortParams;
  filterParams: GetAllGoodsFilterParams;
  sortColumn = '';
  form = new FormGroup({
    crateEntryEventTimestampStartDate: new FormControl(null),
    crateEntryEventTimestampEndDate: new FormControl(null),
    sku: new FormControl(null),
    totalQuantity: new FormControl(null),
    groundPositionAlias: new FormControl(null),
    productDescription: new FormControl(null),
    productName: new FormControl(null),
    inOrderNumber: new FormControl(null),
  });

  constructor() { }

  get isCrateEntryEventTimestampSaveBtnDisabled(): boolean {
    const start = this.form.get('crateEntryEventTimestampStartDate');
    const end = this.form.get('crateEntryEventTimestampEndDate');
  
    const bothDatesValid = start?.valid && end?.valid;
    const bothDatesEmpty = !start?.value && !end?.value;
  
    if (this.showCheckIcon['crateEntryEventTimestamp']) {
      return !(bothDatesValid || bothDatesEmpty);
    } else {
      return !bothDatesValid;
    }
  }

  ngOnInit(): void {
  }

  applyFilters(menu: MatMenuTrigger) {
    const startDate = this.form.value.crateEntryEventTimestampStartDate ? moment(this.form.value.crateEntryEventTimestampStartDate._d).valueOf() : null;
    const endDate = this.form.value.crateEntryEventTimestampEndDate ? moment(this.form.value.crateEntryEventTimestampEndDate._d).endOf('day').valueOf() : null;

    this.filterParams = {
      crateEntryEventTimestampStartDate: startDate,
      crateEntryEventTimestampEndDate: endDate,
      totalQuantity: this.form.value.totalQuantity,
      sku: this.form.value.sku,
      groundPositionAlias: this.form.value.groundPositionAlias,
      productDescription: this.form.value.productDescription,
      productName: this.form.value.productName,
      inOrderNumber: this.form.value.inOrderNumber,
    };

    this.removeNullKeys(this.filterParams);
    this.sortColumn = this.sortParams?.orderBy;
    this.filterValues.emit({
      filterParams: this.filterParams,
      sortParams: this.sortParams
    });
    menu.closeMenu();
  }

  sort(column: GetAllGoodsSortParams['orderBy'], direction: GetAllGoodsSortParams['sortBy']) {
    this.sortParams = null;
    this.showCheckIcon = {};
    this.sortDirection = direction;
    this.showCheckIcon[column] = true;
    this.sortParams = {
      orderBy: column,
      sortBy: direction
    };
  }

  clearFilters(menu: MatMenuTrigger, filter: string) {
    this.maxDate = new Date();
    this.minDate = null;
    this.sortColumn = this.sortColumn === filter ? null : this.sortColumn;
    this.sortParams = this.sortParams?.orderBy === filter ? null : this.sortParams;
    delete this.appliedFilters?.[filter];
    delete this.showCheckIcon?.[filter];

    switch (filter) {
      case 'totalQuantity':
        this.form.get('totalQuantity').reset();
        delete this.filterParams?.['totalQuantity'];
        break;
      case 'crateEntryEventTimestamp':
        this.form.get('crateEntryEventTimestampStartDate').reset();
        this.form.get('crateEntryEventTimestampEndDate').reset();
        delete this.filterParams?.['crateEntryEventTimestampEndDate'];
        delete this.filterParams?.['crateEntryEventTimestampStartDate'];
        break;
      case 'sku':
        this.form.get('sku').reset();
        delete this.filterParams?.['sku'];
        break;
      case 'groundPositionAlias':
        this.form.get('groundPositionAlias').reset();
        delete this.filterParams?.['groundPositionAlias'];
        break;
      case 'productDescription':
        this.form.get('productDescription').reset();
        delete this.filterParams?.['productDescription'];
        break;
      case 'productName':
        this.form.get('productName').reset();
        delete this.filterParams?.['productName'];
        break;
      case 'inOrderNumber':
        this.form.get('inOrderNumber').reset();
        delete this.filterParams?.['inOrderNumber'];
        break;
    }

    this.filterValues.emit({
      filterParams: this.filterParams,
      sortParams: this.sortParams
    });
    menu.closeMenu();
  }

  removeNullKeys(params) {
    Object.keys(params).forEach(key => {
      if (params[key] === null) {
        delete params[key];
      } else {
        this.setAppliedFilters(key);
      }
    });
  }

  setAppliedFilters(name: string) {
    switch (name) {
      case 'crateEntryEventTimestampStartDate':
      case 'crateEntryEventTimestampEndDate':
        this.appliedFilters['crateEntryEventTimestamp'] = true;
        break;
      default:
        this.appliedFilters[name] = true;
        break;
    }
  }

  onEndDateChange() {
    this.maxDate = this.form.value.crateEntryEventTimestampEndDate._d;
  }

  onStartDateChange() {
    this.minDate = this.form.value.crateEntryEventTimestampStartDate._d;
  }

  selectAllGoods() {
    this.onSelectAll.emit();
  }

}
